const tulkojumi = (teksti, key) => {
    const str = (teksti || []).find(str => str._id === key);
    if (str) {
        return str.text;
    }

    if (!teksti) {
        console.error(`[teksti] not defined`);
    } else {
        console.warn(`String with key '${key}' no fount in teksti`);
    }
    return '';
};

export default tulkojumi;



// WEBPACK FOOTER //
// ./src/utils/tulkojumi.js